import { Info } from "@phosphor-icons/react";
import { useMemo } from "react";

import { tagVariants } from "common/components/ui/Tag";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";

export default function ScheduledChangeTag() {
  const { licenses, license_count: licenseCount } =
    useSelectedWorkspaceContext();

  const activeLicenseCount = useMemo(
    () => licenses.filter(({ status }) => status === "active").length,
    [licenses],
  );

  return (
    <Tooltip>
      <TooltipTrigger
        className={tagVariants({ variant: "yellow", icon: "right" })}
      >
        Scheduled change <Info weight="fill" />
      </TooltipTrigger>

      <TooltipContent>
        This subscription has a scheduled change which will be effective
        starting from your next billing date
        <div className="flex flex-col mt-4">
          <span>Current seats: {licenseCount}</span>
          <span>New seats: {activeLicenseCount}</span>
        </div>
      </TooltipContent>
    </Tooltip>
  );
}
